import { useMutation } from "@tanstack/react-query";
import { Button, Form, Input, message } from "antd";
import { useIntl } from "react-intl";
import { addTax } from "../../../network/settings";
import queryClient from "../../../services/react-query/queryClient";

const ModalAddNewTax = ({ close, setTax }: any) => {
  const {
    mutate: addTaxes,
    isLoading,
    error: addTaxError,
  } = useMutation(addTax, {
    onSuccess: (res: any) => {
      if (
        res?.response?.status === 422 ||
        res?.response?.status === 500 ||
        res?.response?.status === 404 ||
        res?.response?.status === 402
      ) {
        message.error(res?.response?.data?.message);
      } else {
        console.log(res?.data, "res");
        message.success("Tax added successfully");
        queryClient.invalidateQueries(["Taxes"]);
        close();
        setTax(res?.data);
      }
    },
  });
  const onFinish = (values: any) => {
    addTaxes(values);
  };
  const intl = useIntl();
  return (
    <div className="text-center lg:p-10">
      <div className="text-center">
        <h4 className="text-2xl font-semibold text-color-primary">
          {intl.formatMessage({ id: "addTaxValue.title" })}
        </h4>
        <p className="text-base text-[#75757E] mt-4">
          {intl.formatMessage({ id: "addTaxValue.description" })}
        </p>
      </div>
      <Form
        name="SaleGiftCard"
        onFinish={onFinish}
        layout={"vertical"}
        className="flex flex-col items-center justify-center w-full mt-8"
      >
        <div className="flex items-center w-full gap-4">
          <Form.Item
            name={["name", "ar"]}
            label={intl.formatMessage({ id: "taxNameAr" })}
            className="w-full"
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "taxNameRequired" }),
              },
            ]}
            required={false}
          >
            <Input
              className="w-full"
              placeholder={intl.formatMessage({ id: "enterName" })}
            />
          </Form.Item>
          <Form.Item
            name={["name", "en"]}
            label={intl.formatMessage({ id: "taxNameEn" })}
            className="w-full"
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "taxNameRequired" }),
              },
            ]}
            required={false}
          >
            <Input
              className="w-full"
              placeholder={intl.formatMessage({ id: "enterName" })}
            />
          </Form.Item>
          <Form.Item
            labelAlign="left"
            name={"tax_rate"}
            label={intl.formatMessage({ id: "taxValue" })}
            className="w-full"
            rules={[
              {
                required: true,
                message: intl.formatMessage({ id: "taxValueRequired" }),
                validator: (_, value) => {
                  const numericValue = parseFloat(value);
                  if ((value && isNaN(numericValue)) || numericValue < 0) {
                    return Promise.reject(
                      intl.formatMessage({
                        id: "validNumberGreaterThanZero",
                      })
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
            required={false}
          >
            <Input
              className="w-full"
              placeholder={intl.formatMessage({ id: "enterValue" })}
              type="number"
              min={0}
              suffix={<div className="font-semibold text-color-primary">%</div>}
            />
          </Form.Item>
        </div>
        <div className="flex items-center justify-between w-full gap-2 mt-8">
          <Button type="primary" loading={isLoading} block htmlType="submit">
            {intl.formatMessage({ id: "add" })}
          </Button>
          <Button
            type="primary"
            onClick={() => close()}
            block
            className="btn-primary-not"
            htmlType="button"
          >
            {intl.formatMessage({ id: "cancel" })}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ModalAddNewTax;
